import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
export function DrugDevelopmentFunnel() {
  const stages = ['Discovery', 'Preclinical', 'Clinical', 'Approval'];
  return <div className="w-full py-6 flex flex-col items-center justify-center" data-id="element-33">
      <div className="relative w-full max-w-[320px] mb-8" data-id="element-34">
        {/* Connecting Line */}
        <div className="absolute top-1/2 left-0 w-full h-1 bg-white/10 -translate-y-1/2 rounded-full" data-id="element-35" />

        <div className="flex justify-between relative z-10" data-id="element-36">
          {stages.map((stage, i) => {
          const isHighlighted = i === 1; // Preclinical
          return <div key={stage} className="flex flex-col items-center relative" data-id="element-37">
                <motion.div initial={{
              scale: 0,
              opacity: 0
            }} animate={{
              scale: 1,
              opacity: 1
            }} transition={{
              delay: i * 0.2,
              type: 'spring'
            }} className={`w-4 h-4 rounded-full border-2 mb-2 ${isHighlighted ? 'bg-[#4B9FE1] border-[#4B9FE1] shadow-[0_0_15px_rgba(75,159,225,0.5)]' : 'bg-[#0B1623] border-slate-500'}`} data-id="element-38" />

                {/* Red Failure Markers between stages */}
                {i < stages.length - 1 && <motion.div initial={{
              opacity: 0,
              y: -10
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: 0.8 + i * 0.2
            }} className="absolute top-1/2 left-[calc(50%+20px)] -translate-y-1/2 text-red-400/80" data-id="element-39">
                    <XCircleIcon className="w-4 h-4" data-id="element-40" />
                  </motion.div>}

                <motion.span initial={{
              opacity: 0
            }} animate={{
              opacity: 1
            }} transition={{
              delay: i * 0.2 + 0.1
            }} className={`text-[10px] font-medium absolute top-6 whitespace-nowrap ${isHighlighted ? 'text-[#4B9FE1]' : 'text-slate-400'}`} data-id="element-41">
                  {stage}
                </motion.span>

                {/* Highlight Label */}
                {isHighlighted && <motion.div initial={{
              opacity: 0,
              y: 10
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: 1.5
            }} className="absolute top-12 w-32 text-center" data-id="element-42">
                    <div className="text-xs font-semibold text-[#4B9FE1] bg-[#4B9FE1]/10 border border-[#4B9FE1]/20 rounded px-2 py-1 backdrop-blur-sm" data-id="element-43">
                      Biological uncertainty
                    </div>
                  </motion.div>}
              </div>;
        })}
        </div>
      </div>

      <motion.p initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.8
    }} className="text-xs text-slate-400 text-center mt-8 max-w-[250px]" data-id="element-44">
        Where target engagement and tumour response are still unclear.
      </motion.p>
    </div>;
}